import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";

const contentWindowsSubject = new BehaviorSubject({});

export const setContentWindow = (key: string, value: any) => {
  contentWindowsSubject.next({
    ...contentWindowsSubject.getValue(),
    [key]: value,
  });
};

export const getContentWindows = () => contentWindowsSubject;

export const getContentWindow = (key: string) => {
  return contentWindowsSubject.pipe(
    map((contentWindows) => contentWindows[key])
  );
};
